import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    phoneNumberFieldContainer: {
      width: '100%',
      '& .iti': {
        width: '100%',
        border: 'none',
      },
    },
    phoneNumberInput: {
      width: '100%',
      height: '48px',
      border: theme.customBorders.gray300,
      boxShadow: 'none',
      borderRadius: 5,
      '&.invalid-number': {
        border: theme.customBorders.gray300,
      },
      '&$withError': {
        borderRadius: 5,
        border: `1px solid ${theme.palette.common.red400}`,
      },
      '&:focus-visible': {
        outline: 'none',
        border: `2px solid ${theme.palette.common.black}`,
        boxShadow: 'none',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: 'none',
      },
      '&:disabled': {
        color: theme.palette.common.gray300,
        backgroundColor: theme.palette.common.gray300,
      },
    },
    withError: {
      borderRadius: 5,
      border: `1px solid ${theme.palette.common.red400}`,
    },
  }),
);
